<script lang="ts">
    import ColumnsColumn from "./Columns_Column.svelte"

    export let block: ContentBlock<"columns">
</script>

<div class="col-container">
    <div class="row">
        {#each block.columns as column}
            <ColumnsColumn {column} />
        {/each}
    </div>
</div>

<style lang="less">
    :global .col-container {
        width: 100%;
        .row {
            width: 100%;
            align-items: flex-start !important;
            & > div:first-child {
                width: 40%;
                flex-grow: 1;
            }
            & > div:last-child {
                width: 60%;
                flex-grow: 1;
            }
            &:only-child {
                & > div:first-child,
                & > div:last-child {
                    width: 100%;
                }
            }
        }
    }
</style>
